<script setup lang="ts">
import {
  showMemberDialog,
  packageList,
  packageIndex,
  closeMemberDialog,
  payCodeUrl,
  packageInfo,
  validCode,
  getPayCode,
} from "./member";

import useStore from "@/stores/publicStore";
import { storeToRefs } from "pinia";

const publicStore = useStore();
const { userInfo, vipInfo } = storeToRefs(publicStore);
const jurisdiction = [
  "PPT可编辑源文件下载",
  "海量精品模版随意调用",
  "文件下载记录15天",
  "文件上传空间 200M",
  "回收站保留 15天",
  "无水印在线编辑与导出",
];
</script>

<template>
  <CsdDialog :showDialog="showMemberDialog" rounded="20">
    <div class="member-dialog">
      <div relative h-130 px-30 z-1 class="member-header">
        <div h-110 flex-align justify-between>
          <div flex-align gap-10 text-white text-16>
            <div solid-border border-2 border="#567DE6" rounded-full>
              <CsdImg
                :src="`/images/avatar.png`"
                class="size-40 rounded-full"
              />
            </div>
            <div>{{ userInfo.nickName }}</div>
            <div>|</div>
            <div text="#858899">{{ vipInfo.expiry }}</div>
          </div>
          <div
            class="iconfont ppt-close text-white text-14 cursor-pointer font-100"
            @click="closeMemberDialog"
          ></div>
        </div>
      </div>
      <div relative rounded-20 z-2 bg-white p-20 flex flex-1 truncate>
        <div m-10 relative>
          <CsdImg
            :src="`/images/member/bg-member-left.png`"
            class="w-228 h-full"
          />
          <div full absolute t-0 l-0 flex flex-col px-25 py-50 text="#333">
            <div w-full text-center text-20 font-700 mb-35>VIP畅享特权</div>
            <div
              v-for="(item, index) in jurisdiction"
              :key="index"
              flex-align
              my-10
              text-13
            >
              <CsdImg
                :src="`/images/member/checked.png`"
                class="size-16 mr-10"
              />
              {{ item }}
            </div>
          </div>
        </div>
        <div flex-1 truncate py-10 pl-20 flex flex-col>
          <div text-18 font-700 text="#202123" my-20>选择会员套餐</div>
          <div flex justify-between pb-15>
            <div
              v-for="(item, index) in packageList"
              :key="index"
              class="relative"
              @click="packageIndex = index"
            >
              <div
                w-54
                h-20
                absolute
                flex-center
                l-0
                text-12
                text-white
                z-1
                style="
                  top: -8px;
                  background: linear-gradient(#ff8c09, #ff3400);
                  border-top-left-radius: 10px;
                  border-bottom-right-radius: 10px;
                "
                v-if="index == 0"
              >
                推荐
              </div>
              <div
                :class="{ 'checked-package': packageIndex === index }"
                class="package"
              >
                <div flex-center flex-col flex-1 truncate gap-8>
                  <div font-700 text-black text-14>{{ item.plan_name }}</div>
                  <div text-26 font-700 text="#FF4409">
                    <span text-14>￥</span>{{ item.price }}
                  </div>
                  <div text-12 line-through>￥{{ item.line_price }}</div>
                </div>
                <div
                  w-full
                  flex-center
                  b-0
                  text-12
                  py-8
                  :class="
                    packageIndex === index
                      ? 'bg-#302D5A text-white'
                      : 'bg-#CFDEFF text-#548AFF'
                  "
                >
                  <div v-if="index == 0">限时开放，</div>
                  立省￥{{ item.line_price - item.price }}
                </div>
              </div>
            </div>
          </div>
          <div font-700 my-20 text-14 text="#333333">支付订单</div>
          <div bg="#F9F9FA" rounded-10 flex-1 truncate flex-align>
            <div pl-40 flex>
              <div size-120 relative>
                <CsdImg :src="payCodeUrl" class="size-120" />
                <div
                  v-if="!validCode"
                  full
                  absolute
                  l-0
                  t-0
                  flex-col
                  flex-center
                  justify-center
                  z-5
                  bg="#00000095"
                  text-white
                  cursor-pointer
                  @click="getPayCode"
                >
                  <div>二维码已失效</div>
                  <div hover:text-16 hover:font-bold w-100 h-30 flex-center>
                    点击刷新
                  </div>
                </div>
              </div>
              <div
                flex-1
                truncate
                flex
                flex-col
                justify-center
                gap-20
                ml-15
                text="#333333"
              >
                <div flex items-end>
                  <div text-12>实付：</div>
                  <div text="#FF4409" font-700 text-26>
                    <span text-14>￥</span>{{ packageInfo?.price }}
                  </div>
                  <div
                    bg="#FFE8F1"
                    text="#FF6060"
                    text-12
                    py-5
                    px-7
                    ml-10
                    rounded-4
                  >
                    优惠券优惠￥{{
                      packageInfo?.line_price - packageInfo?.price
                    }}
                  </div>
                </div>
                <div flex-align gap-8 text-12>
                  <CsdImg :src="`/images/member/zhifubao.svg`" />
                  <CsdImg :src="`/images/member/weixin.svg`" />
                  使用微信 / 支付宝扫码支付
                </div>
                <div text-12 text="#999999">支付即视为您同意《会员协议》</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CsdDialog>
</template>

<style lang="scss">
.member-dialog {
  width: 936px;
  height: 640px;
  background-image: url("/images/member/bg-member.png");
  background-size: cover;
  display: flex;
  flex-direction: column;

  .member-header {
    height: 100px;
  }

  .package {
    width: 198px;
    height: 135px;
    border-radius: 8px;
    background: #f7f9fc;
    border: 2px solid #fff;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .checked-package {
    border: 2px solid #8bb9fc;
    background: linear-gradient(90deg, #d2f8ff, #d3e0fe);
  }
}
</style>
